import { apiConfig } from '../config/api'
import { adaptSseEventToTracePatch } from '../adapters/assistantTrace.adapter'

export async function streamMessage(body, options) {
  const { onToken, onDone, onError, onTracePatch } = options
  const tokenObj = apiConfig.apiKey
  const baseUrl = apiConfig.baseUrl || ''
  const url = `${baseUrl.replace(/\/$/, '')}${apiConfig.conversationsEndpoint}`

  const decoder = new TextDecoder()
  let buffer = ''

  try {
    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${tokenObj}`,
      },
      body: JSON.stringify(body)
    })

    if (resp.status === 401) {
      // reaouth() // 触发全局的登录失效逻辑
      return
    }

    if (!resp.ok) {
      const text = await resp.text().catch(() => '')
      throw new Error(text ? `请求失败(${resp.status}): ${text}` : `请求失败(${resp.status})`)
    }

    const reader = resp.body && resp.body.getReader ? resp.body.getReader() : null
    if (!reader) {
      throw new Error('响应不支持流式读取')
    }

    let raw = ''

    let done = false
    while (!done) {
      const readResult = await reader.read()
      done = Boolean(readResult.done)
      const value = readResult.value
      if (done) break
      if (!value) continue

      const chunk = decoder.decode(value, { stream: true })
      raw += chunk
      buffer += chunk

      const lines = buffer.split('\n')
      buffer = lines.pop() || ''

      for (const line of lines) {
        const trimmed = line.trim()
        if (!trimmed.startsWith('data:')) continue
        const payloadText = trimmed.slice(5).trim()
        if (!payloadText) continue

        let event
        try {
          event = JSON.parse(payloadText)
        } catch {
          continue
        }

        const patch = onTracePatch ? adaptSseEventToTracePatch(event) : null
        if (patch && onTracePatch) {
          onTracePatch(patch)
        }

        if (event && event.type === 'stream' && typeof event.message === 'string') {
          if (onToken) onToken(event.message)
        }
        if (event && event.type === 'error') {
          const msg = typeof event.message === 'string' && event.message ? event.message : '服务异常'
          throw new Error(msg)
        }
      }
    }

    if (buffer.trim().startsWith('data:')) {
      const payloadText = buffer.trim().slice(5).trim()
      try {
        const event = JSON.parse(payloadText)
        const patch = onTracePatch ? adaptSseEventToTracePatch(event) : null
        if (patch && onTracePatch) {
          onTracePatch(patch)
        }
        if (event && event.type === 'stream' && typeof event.message === 'string') {
          if (onToken) onToken(event.message)
        }
      } catch (e) {
        // ignore
      }
    }

    if (onDone) onDone(raw)
  } catch (error) {
    if (onError) onError(error)
  }
}
